import { getIn } from "@utils/index"
import { useEffect, useState } from "react"

export function useNotAvailableInCountry({
  customerCountryCode,
  fetched,
  productSlug,
  rules,
}: {
  customerCountryCode?: string
  fetched?: boolean
  productSlug?: string
  rules?: any[]
}) {
  const [blocked, setBlocked] = useState(false)
  const [message, setMessage] = useState<string | undefined>(undefined)

  useEffect(() => {
    if (!fetched || !rules || !customerCountryCode || !productSlug) return
    for (const rule of rules) {
      const countries = getIn(rule, "countries", [])
      const products = getIn(rule, "products", [])
      if (countries.includes(customerCountryCode)) {
        const found = products.find(({ slug }) => slug === productSlug)
        if (found) {
          setBlocked(true)
          setMessage(rule.message)
          return
        }
      }
    }
    setBlocked(false)
    setMessage(undefined)
  }, [rules, customerCountryCode, productSlug, fetched])

  return { blocked, message }
}
